<template>
  <a-spin size="large" :spinning="loading">
    <div class="home">
      <div class="wrapForm">
        <div class="formBox">
          <div class="title" :class="[lang]">
            {{ $t("infoTips") }}
          </div>
          <a-form layout="vertical" :form="form" size="large">
            <div class="form-label" :class="[lang]">{{ $t("FirstName") }}</div>
            <a-form-item :class="[lang]">
              <a-input
                maxlength="20"
                :placeholder="$t('FirstName')"
                v-decorator="[
                  'first_name',
                  {
                    trigger: 'blur',
                    rules: [
                      {
                        required: true,
                        validator: function (rule, value, callback) {
                          if (!value) {
                            callback($t('required'));
                            return;
                          }
                          callback();
                        },
                      },
                    ],
                  },
                ]"
              >
              </a-input>
            </a-form-item>
            <div class="form-label" :class="[lang]">{{ $t("LastName") }}</div>
            <a-form-item :class="[lang]">
              <a-input
                maxlength="20"
                :placeholder="$t('LastName')"
                v-decorator="[
                  'last_name',
                  {
                    trigger: 'blur',
                    rules: [
                      {
                        required: true,
                        validator: function (rule, value, callback) {
                          if (!value) {
                            callback($t('required'));
                            return;
                          }
                          callback();
                        },
                      },
                    ],
                  },
                ]"
              >
              </a-input>
            </a-form-item>

            <div class="form-label" :class="[lang]">{{ $t("role") }}</div>
            <a-form-item :class="[lang]">
              <a-select
                class="input"
                showSearch
                @change="selectRole"
                v-decorator="[
                  'role',
                  {
                    trigger: ['blur', 'change'],
                    rules: [
                      {
                        required: true,
                        validator: function (rule, value, callback) {
                          if (!value) {
                            callback($t('required'));
                            return;
                          }
                          callback();
                        },
                      },
                    ],
                  },
                ]"
                :placeholder="$t('role')"
              >
                <a-select-option :class="[lang]" :value="1">
                  {{ $t("Solo") }}
                </a-select-option>
                <a-select-option :class="[lang]" :value="2">
                  {{ $t("SalesTeam") }}
                </a-select-option>
                <a-select-option :class="[lang]" :value="3">
                  {{ $t("Recruiter") }}
                </a-select-option>
                <a-select-option :class="[lang]" :value="4">
                  {{ $t("Marketer") }}
                </a-select-option>
                <a-select-option :class="[lang]" :value="5">
                  {{ $t("Agency") }}
                </a-select-option>
                <a-select-option :class="[lang]" :value="6">
                  {{ $t("CustomEntry") }}
                </a-select-option>
                <a-select-option :class="[lang]" :value="7">
                  {{ $t("Freelancer") }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <template v-if="role == 6">
              <div class="form-label" :class="[lang]">
                {{ $t("EnterRole") }}
              </div>
              <a-form-item :class="[lang]">
                <a-input
                  :maxlength="200"
                  :placeholder="$t('EnterRole')"
                  v-decorator="['role_desc']"
                >
                </a-input>
              </a-form-item>
            </template>

            <template v-if="role == 1 || role == 7">
              <div class="form-label" :class="[lang]">
                {{ $t("industry") }}
              </div>
              <a-form-item :class="[lang]">
                <a-select
                  :placeholder="$t('selectInstry')"
                  @change="selectIndustry"
                  v-decorator="[
                    'industry_id',
                    {
                      trigger: ['blur', 'change'],
                      rules: [
                        {
                          required: true,
                          validator: function (rule, value, callback) {
                            if (!value || value == '0') {
                              callback($t('required'));
                              return;
                            }
                            callback();
                          },
                        },
                      ],
                    },
                  ]"
                >
                  <a-select-option
                    :class="[lang]"
                    v-for="(item, index) in industryList"
                    :key="index"
                    :value="index"
                  >
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </template>
            <template v-if="industry_id == 15">
              <div class="form-label" :class="[lang]">
                {{ $t("Enteryourindustry") }}
              </div>
              <a-form-item :class="[lang]">
                <a-input
                  :maxlength="200"
                  :placeholder="$t('Pleaseenteryourindustry')"
                  v-decorator="[
                    'industry_desc',
                    {
                      trigger: ['blur', 'change'],
                      rules: [
                        {
                          required: true,
                          validator: function (rule, value, callback) {
                            if (!value) {
                              callback($t('required'));
                              return;
                            }
                            callback();
                          },
                        },
                      ],
                    },
                  ]"
                >
                </a-input>
              </a-form-item>
            </template>
            <template
              v-if="
                role == 2 || role == 3 || role == 4 || role == 5 || role == 6
              "
            >
              <div class="form-label" :class="[lang]">
                {{ $t("CompanyName") }}
              </div>
              <a-form-item :class="[lang]">
                <a-input
                  :placeholder="$t('CompanyName')"
                  :maxlength="200"
                  v-decorator="[
                    'company_name',
                    {
                      trigger: 'blur',
                      rules: [
                        {
                          required: true,
                          validator: function (rule, value, callback) {
                            if (!value) {
                              callback($t('required'));
                              return;
                            }
                            callback();
                          },
                        },
                      ],
                    },
                  ]"
                >
                </a-input>
              </a-form-item>

              <div class="form-label" :class="[lang]">{{ $t("TeamSize") }}</div>
              <a-form-item :class="[lang]">
                <a-select
                  class="input"
                  :filter-option="filterOption"
                  showSearch
                  v-decorator="[
                    'team_size',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('required'),
                        },
                      ],
                    },
                  ]"
                  :placeholder="$t('TeamSize')"
                >
                  <a-select-option
                    :class="[lang]"
                    v-for="(item, index) in sizeList"
                    :key="index"
                    :value="index"
                    >{{ item }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </template>
            <div class="form-label" :class="[lang]">{{ $t("Location") }}</div>
            <a-form-item :class="[lang]">
              <a-select
                class="input"
                :filter-option="filterOption"
                showSearch
                v-decorator="['location']"
                :placeholder="$t('Location')"
              >
                <a-select-option
                  :class="[lang]"
                  v-for="(item, index) in locationList"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.show_name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item style="text-align: center">
              <a-button
                type="primary"
                html-type="submit"
                style="width: 200px; text-align: center"
                @click="onSubmit"
                :disabled="!haveFormValue()"
              >
                {{ $t("Submit") }}
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
export default {
  name: "collectInfo",
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      sizeList: [],
      role: undefined,
      industry_id: undefined,
      industryList: [],
    };
  },
  created() {
    this.initData();
  },
  i18n: require("./i18n"),
  watch: {
    lang() {
      this.getLocationList();
      this.getSizeList();
    },
  },
  methods: {
    selectIndustry(val) {
      this.industry_id = val;
    },
    selectRole(role) {
      this.role = role;
    },
    initData() {
      this.getLocationList();
      this.getSizeList();
      this.$axios("/public/industry_config", {}, "post").then((res) => {
        if (res.code == 200) {
          this.industryList = res.data;
        }
      });
    },
    getSizeList() {
      return new Promise((resolve, reject) => {
        this.$axios("/public/company_size_config", {}, "post")
          .then((res) => {
            resolve(res.data);
            if (res.code == 200) {
              this.sizeList = res.data;
            }
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    haveFormValue() {
      const { getFieldValue } = this.form;
      let role = getFieldValue("role");
      let company_name = getFieldValue("company_name");
      let team_size = getFieldValue("team_size");

      if (
        (role == 2 || role == 3 || role == 4 || role == 5 || role == 6) &&
        company_name &&
        team_size &&
        role &&
        getFieldValue("first_name") &&
        getFieldValue("last_name")
      ) {
        return true;
      } else if (
        (role == 1 || role == 7) &&
        getFieldValue("first_name") &&
        getFieldValue("last_name")
      ) {
        return true;
      } else {
        return false;
      }
    },
    onSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let { team_size, industry_id } = values;
          this.loading = true;
          this.writeLog(
            "info_colect",
            this.$route.path == "/sales/salesReps/collectUserInfo"
              ? "sales"
              : "recruiter",
            `cilick_submit`
          );
          this.$axios(
            "/public/customer_info",
            {
              ...values,
              team_size: parseInt(team_size),
              industry_id: industry_id ? parseInt(industry_id) : null,
            },
            "post"
          ).then((res) => {
            this.loading = false;
            if (res.code == 200) {
              this.getUserInfo();
              if (this.$route.path == "/sales/salesReps/collectUserInfo") {
                this.$router.replace({
                  path: "/sales/salesReps/createCampaign",
                  query: this.$route.query,
                });
              } else {
                this.$router.replace({
                  path: "/hr/recruiter/createCampaign",
                  query: this.$route.query,
                });
              }
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.home {
  margin-top: 50px;
  padding: 20px 30px;
  display: flex;
  align-items: top;
  justify-content: space-between;
  font-family: Arial, Arial;
  .wrapForm {
    width: 100%;
    background: #fff;
    padding: 30px;
    border-radius: 5px;
    height: 100%;
    .title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 16px;
    }
    .formBox {
      width: 600px;
      margin: 0 auto;
      .form-label {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
